module.exports = __webpack_public_path__ + "static/img/logo.1adf764.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo.png
// module id = Vpqn
// module chunks = 1